import React, { useState } from 'react'
import { postMessage } from './api'
import Checkbox from '../common/components/Checkbox'

function App() {
  const [termsAccepted, setTermsAccepted] = useState(false)
  const [continueEnabled, setContinueEnabled] = useState(true)

  function isSecondary() {
    return gon.user.role === 'secondary'
  }

  function submitEnabled () {
    if (isSecondary()) {
      return !termsAccepted || !continueEnabled
    }

    return !continueEnabled
  }

  const onSubmitSuccess = () => {
    location.replace(location.href)
  }

  const onSubmitFailure = (response) => {
    // Do something on failure
  }

  const onSubmit = () => {
    setContinueEnabled(false)

    postMessage(
      {
        user: {
          confirmed_eligibility: true,
          terms_and_conditions: true,
          terms_accepted_at: new Date(),
        }},
      onSubmitSuccess,
      onSubmitFailure
    )
  }

  return(
    <div>
      { isSecondary() &&
        <div className="card card-invisible">
          <div className="card-body">
            <Checkbox
              checked={ termsAccepted }
              onClick={ (e) =>  setTermsAccepted(e.currentTarget.checked) }
              id='accept-terms'
            >
              I have read and consent to <a href='/pages/privacy' target='_blank'>Yard’s Privacy &amp; Cookies Policy</a>, <a href='/pages/credit-guide' target='_blank'>Credit
              Guide</a> and <a href='/pages/terms' target='_blank'>Website
              Terms &amp; Conditions</a>, and to Yard using my personal information to contact me regarding my application.
            </Checkbox>
          </div>
        </div>
      }

      <div className='text-center'>
        <button className='btn btn-green btn-lg'
                onClick={ onSubmit }
                disabled={  submitEnabled() }
        >
          Continue
        </button>
      </div>
    </div>
  )
}

export default App
